import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
/**
* THIS IS AN AUTO GENERATED FILE, CHANGES WILL NOT APPLY
*/

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.9 3c0-.552-.47-1-1.05-1H3.15c-.58 0-1.05.448-1.05 1v14c0 .552.47 1 1.05 1h14.7c.58 0 1.05-.448 1.05-1V3zM21 2v16c0 1.105-.94 2-2.1 2H2.1C.94 20 0 19.105 0 18V2C0 .895.94 0 2.1 0h16.8c1.16 0 2.1.895 2.1 2zm-6.278 5.015a.966.966 0 010 1.414l-4.082 3.888a1.634 1.634 0 01-2.23 0L6.553 10.55a.967.967 0 010-1.414c.41-.39 1.075-.39 1.485 0l.741.706c.41.391 1.077.391 1.489 0l2.968-2.827a1.086 1.086 0 011.485 0z",
  fillRule: "evenodd"
});

var Done2Icon = function Done2Icon(_ref) {
  var className = _ref.className,
      size = _ref.size,
      rest = _objectWithoutProperties(_ref, ["className", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 20",
    className: className,
    style: {
      width: size * 10,
      height: size * 10
    },
    fill: "undefined",
    focusable: "false"
  }, rest), _ref2);
};

process.env.NODE_ENV !== "production" ? void 0 : void 0;
Done2Icon.defaultProps = {
  size: 1.5
};
export default Done2Icon;